<template>
  <div id="category" class="category" v-if="items.length">
    <div class="category-item" :class="{'category-top': index < 5}" v-for="(category, index) in items" :key="category.id" @click="goPage(category, index)">
      <vanImg class="catetory-img" :src="category.iconUrl | imageToHttps | imageToWebp($webpSurpport)" alt=""/>
      <span :style="{'color': category.fontColor}">{{category.name}}</span>
    </div>
  </div>
</template>

<script>
import { domBgColorSet } from '../common'

export default {
  name: 'categoryItems',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    bgInfo: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      cateBgInfo: this.bgInfo,
    }
  },
  watch: {
    bgInfo(newVal) {
      console.log('category bgInfo==>', newVal)
      this.cateBgInfo = newVal
      this.renderBgInfo()
    },
  },
  mounted() {
    this.renderBgInfo()
  },
  methods: {
    renderBgInfo() {
      domBgColorSet(this.cateBgInfo, 'category')
    },
    goPage(item, index) {
      console.log(item)
      // 埋点
      this.$util.gioTrackWithVariable('MB15593', {
        site_number: index + 1 + '',
        text: item.name || 'null'
      })
      if (item.hyperType === undefined) {
        this.$store.dispatch('bannerTypeFiveClick', { hyperLink: item.linkUrl });
      } else {
        this.$store.dispatch('goPageByType', {
          type: item.hyperType,
          params: item.hyperParam
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.category{
  margin: .24rem .32rem;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: .24rem;
  transform: translateZ(0);
  @include synShadow;
}

.category-item{
  width: 1.37rem;
  margin-bottom: .38rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 9;
  position: relative;
  .catetory-img{
    margin-bottom: .04rem;
    width: .84rem;
    height: .84rem;
    border-radius: .24rem;

    :deep(img) {
    -webkit-touch-callout: none;
    pointer-events: none;
    }
  }
  span{
    display: inline-block;
    width: 100%;
    font-size: .24rem;
    color: #111111;
    text-align: center;
    line-height: .3rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
  }
}
.category-top{
  margin-top: .38rem;
  .catetory-img{
    margin-top: .08rem;
  }
}
</style>
